import React, { useEffect } from 'react';

export default function StripeRouterDeepLink() {
  useEffect(() => {
    window.location.href = `offstore://stripe/success`;
  }, []);

  return <></>;
}
